import React from 'react';
import LinkedInIcon from 'svg/LinkedInIcon';
import { LINKEDIN_URL } from './consts';
import useStyles from './styles';

interface IProps {
}

const Footer: React.FC<IProps> = () => {
  const classes = useStyles();

  return (
    <footer className={classes.root}>
      <div className={classes.copyright}>
        <p className={classes.copyrightLabel}>
          {`©MySky ${new Date().getFullYear()}, All rights reserved`}
        </p>

        <div className={classes.followUs}>
          <p className={classes.titleLabel}>Follow us</p>
          <a href={LINKEDIN_URL} target="_blank" rel="noreferrer">
            <LinkedInIcon />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
